<template>
  <div>
    <Layout :pagetitle="$t('Users')">
      <Table
        :title="$t('Users')"
        :items="users"
        :columns="columns"
        :totalItems="totalItems"
        :showButtons="true"
        :searchable="true"
        :editable="true"
        :removable="true"
        :showPagination="true"
        @onSearch="onSearch"
        @onEdit="editUser"
        @onCreate="createUser"
        @onRemove="onRemove"
        @onChangePage="changePage"
        :customActionBtn="true"
        :customActionName="$t('Unlock MFA')"
        @customAction="showModalMfaUser"
      />
    </Layout>
    <b-modal v-model="modalMfaUser" :title="$t('Unlock MFA')" ok-only @ok="unlockMfaUser">
      <b-row>
        <b-col>
          {{ $t('Do you want to unlock the MFA for this user?') }} <b>{{ user.name }}</b>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';

export default {
  components: { Layout, Table },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      modalMfaUser: false,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'email',
          label: 'E-Mail'
        }
      ],
      users: [],
      user: {}
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    showModalMfaUser(item) {
      this.user = this.$utils.getObjectRaw(item);
      this.modalMfaUser = true;
    },
    unlockMfaUser() {
      this.$api
        .post(`api/user/mfa/unlock/${this.user.id}`)
        .then(() => {
          this.modalMfaUser = false;
          this.$customAlert({
            type: 'success',
            msg: this.$t('User was unlocked with success')
          });
        })
        .catch((err) => {
          this.$customAlert({
            type: 'warning',
            msg: this.$t(err?.response?.data?.message || 'update user error')
          });
        });
    },
    changePage(page) {
      this.page = page;
      this.getUsers();
    },
    onRemove(user) {
      this.$api.destroy(`api/user/${user.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('User was excluded with success')
        });
        this.getUsers();
      });
    },
    getUsers() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/user', { search: this.search, page: this.page })
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.users = res.data?.results || [];
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    createUser() {
      this.$router.push({
        name: 'userCreate'
      });
    },
    editUser(user) {
      this.$router.push({
        name: 'userUpdate',
        params: {
          id: user.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getUsers();
    }
  }
};
</script>

<style></style>
